$(function () {

  // chat open
  function chatbotOpen() {
    $('.js-chatbotAgreeBtn').hide();
    var $targetIframe = $('.js-chatbot-contents').find('iframe');
    var iframeSrc = $targetIframe.attr('data-src');
    if(!($targetIframe.attr('src').length)) {
      $targetIframe.attr('src',iframeSrc)
    }
    $('.js-chatbot-contents').addClass('is-open');
    $('.js-chatbot-close').fadeIn('fast');
  }

  //chat close
  function chatbotClose() {
    $('.js-chatbotAgreeBtn').fadeIn('fast');
    $('.js-chatbot-contents').removeClass('is-open');
    $('.js-chatbot-close').hide();
  }

  // agree modal
  function chatbotAgreeOpen() {
    $.magnificPopup.open({
      items: [
        {
          src: '#chatbotAgree',
          type: 'inline',

        }
      ],
      mainClass: 'p-whiteBackModal',
      closeOnBgClick: false,
      closeBtnInside: false,
      showCloseBtn: true,
      fixedContentPos: true,
      callbacks: {
        open: function(){
          const scrollpos = $(window).scrollTop()
          $('body').css('overflow','hidden');
          $('body').css('height','100%');
          $('html').css('height','100%');
          $('.l-container').css({
            position: 'fixed',
            height: '100%',
            overflow: 'hidden',
            width: '100%',
            top: -scrollpos,
          })
          .attr('data-top', scrollpos)
        },
        close: function(){
          $('body').css('overflow','auto');
          $('body').css('height','auto');
          $('html').css('height','auto');
          const returnpos = parseInt($('.l-container').attr('data-top'))
          $('.l-container').removeAttr('style')
          $(window).scrollTop(returnpos)
        }
      }
    }, 0);
  }


  $('.js-chatbot-open').on('click', function(){
    $.magnificPopup.close();
    chatbotOpen()
  });

  $('.js-chatbot-close').on('click', function(){
    chatbotClose()
  });

  $(document).on('click touchend','.js-chatbotAgreeBtn',  function() {
    chatbotAgreeOpen();
    return false;
  });

  $(document).on('click touchend','.js-chatbotAgreeModalClose',  function(e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  // spのみフッター上部でフロートを止める
  $(window).on('scroll',function () {
    if ($('body').css('min-width') != '1060px') {
      if($('.js-chatbot-area').length) {
        var footerPos = $(".l-footer-siteMenu").offset().top - window.innerHeight;
        var btnPos = $(window).scrollTop() - footerPos - 10;
        var flag = false;
        if($(window).scrollTop() > footerPos) {
          if(!flag) {
            flag = true;
            $('.js-chatbot-area').css({
              'bottom': btnPos + 'px',
            });
          }
        } else {
          flag = false;
          $('.js-chatbot-area').css({
            'bottom':'0px',
          });
        }
      }
    }
  });
  $(window).on('resize',function () {
    if ($('body').css('min-width') != '1060px') {
      if($('.js-chatbot-area').length) {
        var footerPos = $(".l-footer-siteMenu").offset().top - window.innerHeight;
        var btnPos = $(window).scrollTop() - footerPos - 10;
        var flag = false;
        if($(window).scrollTop() > footerPos) {
          if(!flag) {
            flag = true;
            $('.js-chatbot-area').css({
              'bottom': btnPos + 'px',
            });
          }
        } else {
          flag = false;
          $('.js-chatbot-area').css({
            'bottom':'0px',
          });
        }
      }
    }
  });
});
